/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorWorkspaceUserDto } from '../../models/vendor-workspace-user-dto';

export interface VendorWorkspaceUserControllerDeportUser$Params {

/**
 * 입점사 ID
 */
  id: string;

/**
 * 삭제 할 구성원 ID
 */
  userId: string;
}

export function vendorWorkspaceUserControllerDeportUser(http: HttpClient, rootUrl: string, params: VendorWorkspaceUserControllerDeportUser$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceUserDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceUserControllerDeportUser.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorWorkspaceUserDto>;
    })
  );
}

vendorWorkspaceUserControllerDeportUser.PATH = '/api/vendorWorkspaceUser/{id}/deport/{userId}';
